// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__tJHfD","shareEmailBtn":"EmailShare_shareEmailBtn__k70OB","emailSvg":"EmailShare_emailSvg__MRSWB"};